import { render } from "./WKHeader.vue?vue&type=template&id=06779410&scoped=true"
import script from "./WKHeader.vue?vue&type=script&lang=js"
export * from "./WKHeader.vue?vue&type=script&lang=js"

import "./WKHeader.vue?vue&type=style&index=0&id=06779410&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\v202008\\wike-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06779410"]])

export default __exports__